import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

// sing_in
export const userSingIn = (creds) => (dispatch) => {
  let payload = { ...creds, 'device_type': 'web' }
  dispatch(addEventLog(payload, CONSTANTS.LOGIN_REQUEST))
  dispatch({ type: CONSTANTS.LOGIN_REQUEST })
  return postRequest(APICONFIG.singInUrl, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.LOGIN_SUCCESS))
    dispatch({ type: CONSTANTS.LOGIN_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.LOGIN_FAILURE))
    dispatch({ type: CONSTANTS.LOGIN_FAILURE })
    return err
  })
}

// sing_up

export const userSingUp = (creds) => (dispatch) => {
  let payload = { ...creds, 'device_type': 'web' }
  dispatch(addEventLog(payload, CONSTANTS.SINGUP_REQUEST))
  dispatch({ type: CONSTANTS.SINGUP_REQUEST })
  return postRequest(APICONFIG.singupUrl, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.SINGUP_SUCCESS))
    dispatch({ type: CONSTANTS.SINGUP_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.SINGUP_FAILURE))
    dispatch({ type: CONSTANTS.SINGUP_FAILURE })
    return err
  })
}

// send OTP for signup verification
export const sendOtp = (payload) => (dispatch) => {
  dispatch(addEventLog(payload, CONSTANTS.SEND_OTP_REQUEST))
  dispatch({ type: CONSTANTS.SEND_OTP_REQUEST })
  return postRequest(APICONFIG.sendOtpUrl, payload).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.SEND_OTP_SUCCESS))
    dispatch({ type: CONSTANTS.SEND_OTP_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payload, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.SEND_OTP_FAILURE))
    dispatch({ type: CONSTANTS.SEND_OTP_FAILURE })
    return err
  })
}


// export const logoutRequest = () => {
//   return (dispatch) => {
//     dispatch({ type: CONSTANTS.LOGOUT_REQUEST })
//   }
// }

export const getVehicleDetailsList = (code = '') => (dispatch) => {
  dispatch({ type: CONSTANTS.GET_VEHICLE_REQUEST })
  let url = (code !== '') ? `${APICONFIG.getVehicleDetailsUrl}/${code}` : `${APICONFIG.getVehicleDetailsUrl}`
  return getRequest(url).then((res) => {
    let data = { ...res.data }
    let country = data?.country?.filter(item => item?.country_code == 'CA' || item?.country_code == 'US')
    data['country'] = country
    dispatch({ type: CONSTANTS.GET_VEHICLE_SUCCESS, data: data })
    return data
  }).catch(() => {
    dispatch({ type: CONSTANTS.GET_VEHICLE_FAILURE })
  })
}